// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__eJJ+K","header_mobile":"Navbar_header_mobile__YPrDL","logo":"Navbar_logo__Jp5Kx","headertxt":"Navbar_headertxt__sqGGw"};